<template>
    <BannerComponent title="Ponerse en contacto" show="true"
        paragraph="Aquí encontraras nuestras vias de contactos y redes sociales, tambien puedes dejarnos un mensaje o agendar tu cita."
        colorTitle="black" colorParagraph="gray" backgroundColor="white"
        urlImg="" aligmentContent="center"
        paddingY="80px" />
    <FormContact />
</template>

<script>
import FormContact from '../components/FormContact-component.vue'
import BannerComponent from '../components/Banner-component.vue'
export default {
    name: 'ContactPage',
    components: {
        FormContact,
        BannerComponent,
    }
}
</script>